const topics = [
  { name: '下拉式漫画推荐', heat: '9.8万', icon: 'ri-fire-line', color: 'text-primary-500' },
  { name: '日漫连载更新', heat: '8.6万', icon: 'ri-sun-line', color: 'text-secondary-500' },
  { name: '韩漫全彩高清', heat: '7.3万', icon: 'ri-palette-line', color: 'text-accent-500' },
  { name: '热血格斗漫画', heat: '6.9万', icon: 'ri-sword-line', color: 'text-primary-500' },
  { name: '恋爱甜漫合集', heat: '6.5万', icon: 'ri-heart-line', color: 'text-secondary-500' },
  { name: '悬疑推理神作', heat: '5.8万', icon: 'ri-search-line', color: 'text-accent-500' },
  { name: '免费漫画网站', heat: '5.2万', icon: 'ri-star-line', color: 'text-primary-500' },
  { name: '下拉式全集', heat: '4.9万', icon: 'ri-book-open-line', color: 'text-secondary-500' },
  { name: '在线看漫画', heat: '4.6万', icon: 'ri-global-line', color: 'text-accent-500' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            当下最受漫友关注的热门话题和讨论方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((item, idx) => (
            <div
              key={idx}
              className="group flex items-center gap-3 px-5 py-3 bg-background-50 rounded-full border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <i className={`${item.icon} ${item.color} text-base`}></i>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                {item.name}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                {item.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}